import QuestionsAndAnswersPage from "../../features/dashboard/quiz/QuestionsAndAnswersPage";

function QuestionsAndAnswersDB() {
  return <QuestionsAndAnswersPage />;
}

export default QuestionsAndAnswersDB;
